import React from 'react';
import { Truck, Package, Shield, MapPin } from 'lucide-react';
import { shippingImages } from '../data/mock';

const ShippingSection = () => {
  const openChatbot = () => {
    window.dispatchEvent(new CustomEvent('open-chatbot', { detail: { context: 'Consulta de Frete' } }));
  };

  return (
    <section className="py-20 bg-stone-800/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-amber-500 font-semibold text-sm tracking-wider uppercase">Entrega</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-2 mb-4">
            Enviamos para <span className="text-amber-500">Todo o Brasil</span>
          </h2>
          <p className="text-stone-400 max-w-3xl mx-auto text-lg">
            Mandamos para todo o Brasil com cuidado e segurança para que sua churrasqueira chegue perfeita! 
            Convide os amigos, a família e faça aquele costelão saboroso e gostoso! 🥩
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left - Shipping Features */}
          <div>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-amber-500/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Package className="w-6 h-6 text-amber-500" />
                </div>
                <div>
                  <h3 className="text-white font-bold text-lg mb-1">Embalagem Reforçada</h3>
                  <p className="text-stone-400">Sua rotativa vai protegida com embalagem reforçada e plástico bolha para máxima segurança no transporte.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-amber-500/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Shield className="w-6 h-6 text-amber-500" />
                </div>
                <div>
                  <h3 className="text-white font-bold text-lg mb-1">Proteção Total</h3>
                  <p className="text-stone-400">Cada peça é envolvida com cuidado para garantir que chegue perfeita na sua casa.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-amber-500/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Truck className="w-6 h-6 text-amber-500" />
                </div>
                <div>
                  <h3 className="text-white font-bold text-lg mb-1">Entrega Segura</h3>
                  <p className="text-stone-400">Trabalhamos com transportadoras confiáveis para entregar em qualquer lugar do Brasil.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-amber-500/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-amber-500" />
                </div>
                <div>
                  <h3 className="text-white font-bold text-lg mb-1">De Panambi/RS para Você</h3>
                  <p className="text-stone-400">Fabricado no Rio Grande do Sul com orgulho gaúcho e enviado para todo o país!</p>
                </div>
              </div>
            </div>

            <button
              data-testid="shipping-cta-btn"
              onClick={openChatbot}
              className="mt-8 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-xl font-bold transition-all hover:scale-105 flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Consultar Frete
            </button>
          </div>

          {/* Right - Shipping Photos */}
          <div className="grid grid-cols-2 gap-4">
            {shippingImages.map((item, index) => (
              <div
                key={index}
                className={`relative rounded-xl overflow-hidden ${index === 0 ? 'col-span-2' : ''}`}
              >
                <img
                  src={item.image}
                  alt={item.caption}
                  className="w-full h-48 object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
                  <p className="text-white text-sm font-medium">{item.caption}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShippingSection;
